import { render, staticRenderFns } from "./AddMessenger.vue?vue&type=template&id=454b7344"
import script from "./AddMessenger.vue?vue&type=script&lang=js"
export * from "./AddMessenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports